var path = '/app/components/ui/droppable-box/droppable-box.html';
var html = "<div class=box ng-class=$ctrl.class ui-on-drop=$ctrl.onDropWord($data)>{{$ctrl.wordDropped}}</div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/ui/droppable-box/droppable-box.html
// module id = 173
// module chunks = 0